<template>
    <az-toolbar style="margin-top: 10px !important;">
        <az-search style="margin-top: 10px !important;" slot="simpleSearch" :filter="filtros"
                   :simple-search-placeholder="placeholderPesquisa"
                   @simple-search="(valor) => $emit('eventoBuscaSimples', valor)"
                   @remove-filter="(key) => $emit('eventoRemoverFiltro', key)"
                   @advanced-search="processarBuscarAvancada"
                   @clear="resetFiltros">

            <div v-if="filtroCompleto" slot="search-items" class="mt-5" style="max-height: calc(100vh - 300px) !important; overflow-y: auto;">
              <az-search-item>
                <v-form>
                  <v-flex xs12 sm12 d-block>
                    <v-layout wrap align-center white>
                      <v-flex xs12 d-flex class="pl-0">
                        <v-text-field label="Número do processo" name="Nº Processo" key="Nº-Processo" type="text"
                                      v-model="value.processo" placeholder="Ex. PP/0001/2024"
                                      v-validate="'max:20'"
                                      :error-messages="errors.collect('Nº Processo')"/>
                      </v-flex>

                      <v-flex xs12 d-flex>

                        <v-text-field v-model="value.objeto" label="Parte do objeto" name="Parte do objeto"
                                      key="Parte-do-objeto"
                                      placeholder="Ex. Compra de cadeiras" type="text" v-validate="'max:100'"
                                      :error-messages="errors.collect('Parte do objeto')"/>
                      </v-flex>

                      <v-flex xs12 d-flex>
                        <v-text-field v-model="value.orgao" label="Órgão" name="Órgão"
                                      key="Órgão"
                                      placeholder="Ex. Nome ou Sigla do órgão" type="text" v-validate="'max:100'"
                                      :error-messages="errors.collect('Órgão')"/>
                      </v-flex>

                      <v-flex xs12>
                        <p class="mb-2 text--secondary"><strong>Marque uma ou mais situações</strong></p>
                        <v-checkbox  class="pa-0 ma-0"
                                     v-model="situacoes"
                                     v-for="[name, value] in Object.entries(situacoesPossiveis)"
                                     :key="name" :value="name" :label="value"
                                      @change="$emit('updateSituacoes', situacoes)">
                        </v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-form>
              </az-search-item>
            </div>
        </az-search>
    </az-toolbar>
</template>

<script>
export default {
    name: 'CompraDiretaFerramentaDeBusca',
    $_veeValidate: {
        validator: 'new'
    },
    props: {
        value: {
            type: Object,
            required: true
        },
        situacoesPossiveis: {
            type: Object,
            default: () => {}
        },
        filtros: {
            type: Object,
            default: () => {}
        },
        placeholderPesquisa: {
            type: String,
            default: 'Busca por órgão, processo, situação, etc...'
        },
        filtroCompleto: {
            type: Boolean,
            default: true
        }
    },
    data: () =>({
        situacoes: []
    }),
    methods: {
        async processarBuscarAvancada() {
            if(Object.values(this.value).every(value => (!value || (value instanceof Array && value.length <= 0))))
                throw new Error('Preencher ao menos um campo !')

            const {_base, errors} =  await this.$validator.valueOf()

            if((await _base.validateAll())) {
                this.$emit('eventoBuscaAvancada')
            }else
                throw new Error(errors.items.map(item => item.msg))
        },
        resetFiltros(){
            this.situacoes = []
            this.$emit('eventoRemoverFiltro')
        }
    }
}
</script>

<style lang="stylus">
    .az-search .v-navigation-drawer .actions
        bottom  130px !important

</style>